//

export const CONTRIBUYENTES_SET_RESPONSE_PARAMETROS =
  "contribuyentes/PARAMETERS"

export const CONTRIBUYENTES_UNSET_MENSAJE_EXITO =
  "contribuyentes/UNSET_MENSAJE_EXITO"

export const CONTRIBUYENTES_UNSET_ERROR = "contribuyentes/UNSET_ERROR"

export const CONTRIBUYENTES_GET_LISTA = "contribuyentes/LISTA"
export const CONTRIBUYENTES_GET_LISTA_SUCCESS = "contribuyentes/LISTASUCCESS"
export const CONTRIBUYENTES_GET_LISTA_FAIL = "contribuyentes/LISTAFAIL"

export const CONTRIBUYENTES_GET_OPTIONS = "contribuyentes/OPTIONS"
export const CONTRIBUYENTES_GET_OPTIONS_SUCCESS =
  "contribuyentes/OPTIONSSUCCESS"
export const CONTRIBUYENTES_GET_OPTIONS_FAIL = "contribuyentes/OPTIONSFAIL"

export const CONTRIBUYENTES_GET_BUSQUEDA = "contribuyentes/BUSQUEDA"
export const CONTRIBUYENTES_GET_BUSQUEDA_SUCCESS =
  "contribuyentes/BUSQUEDASUCCESS"
export const CONTRIBUYENTES_GET_BUSQUEDA_FAIL = "contribuyentes/BUSQUEDAFAIL"

export const CONTRIBUYENTES_POST_CREATE = "contribuyentes/CREATE"
export const CONTRIBUYENTES_POST_CREATE_SUCCESS = "contribuyentes/CREATESUCCESS"
export const CONTRIBUYENTES_POST_CREATE_FAIL = "contribuyentes/CREATEFAIL"

export const CONTRIBUYENTES_PUT_UPDATE = "contribuyentes/UPDATE"
export const CONTRIBUYENTES_PUT_UPDATE_SUCCESS = "contribuyentes/UPDATESUCCESS"
export const CONTRIBUYENTES_PUT_UPDATE_FAIL = "contribuyentes/UPDATEFAIL"

export const CONTRIBUYENTES_DEL_DELETE = "contribuyentes/DELETE"
export const CONTRIBUYENTES_DEL_DELETE_SUCCESS = "contribuyentes/DELETESUCCESS"
export const CONTRIBUYENTES_DEL_DELETE_FAIL = "contribuyentes/DELETEFAIL"
